export class DateUtil {
    /**
     * Comparing two dates are equal
     * @{see https://stackoverflow.com/questions/492994/compare-two-dates-with-javascript}
     */
    public static areEqual(date: Date, anotherDate: Date): boolean {
        return date.getTime() === anotherDate.getTime();
    }
}
